import * as COMPONENT from '@Components'
import { Outlet } from 'react-router-dom'

export default function Wrapper(props) {
  return (
    <>
      <COMPONENT.Navbar />
      <Outlet />
      <COMPONENT.Footer />
    </>
  )
}